





















































import Vue from "vue";
import { Room } from "../../interfaces";
import { deleteRoom, getAvailableRooms } from "../../services";
import RoomForm from "./RoomForm.vue";

export default Vue.extend({
  components: {
    RoomForm,
  },
  data: () => ({
    rooms: [] as any,
    headers: [
      {
        text: "Name",
        value: "title",
      },
      { text: "Wegbeschreibung", value: "location", sortable: false },
      { text: "Icons", value: "icons", sortable: false },
      { text: "Aktionen", value: "actions", sortable: false },
    ],
    selectedItem: {} as Room,
    logoForDialog: {},
    dialogDelete: false,
    showLogoDialog: false,
  }),
  async created() {
    this.rooms = await getAvailableRooms();
  },
  methods: {
    closeDelete() {
      this.selectedItem = {} as Room;
      this.dialogDelete = false;
    },
    deleteItem(item) {
      this.selectedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      await deleteRoom(this.selectedItem.id);
      this.selectedItem = {} as Room;
      this.rooms = await getAvailableRooms(true);
      this.dialogDelete = false;
    },
    async closeEditDialog(updateLogos: boolean) {
      if (updateLogos) {
        this.rooms = await getAvailableRooms(true);
      }
      this.showLogoDialog = false;
      this.selectedItem = {} as Room;
    },
    editItem(room?: Room) {
      if (room) {
        this.selectedItem = Object.assign({}, room);
      } else {
        this.selectedItem = {} as Room;
      }
      this.showLogoDialog = true;
    },
  },
});
